
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.847 1.217a.75.75 0 000 1.061L5.563 7 .847 11.722a.75.75 0 101.06 1.06L7.154 7.53a.75.75 0 000-1.06L1.908 1.218a.75.75 0 00-1.06 0z","fill":"currentColor"}})])
          )
        }
      }
    